import React, { useState } from "react";
import { useDocument } from "../loan_tool";
import { useUser } from "../../../hooks/user";
import "./css/ba_forms.scss";

export default function BorrowerAuthCert() {
  const [{ companyProfile }] = useUser();
  const [document, , { documentAccountProfile }] = useDocument();

  const [sigDates, setSigDates] = useState(["", "", "", ""]);

  const borrowers = (document.applicant && document.applicant.borrowers) || [];

  const loName = [documentAccountProfile.first_name, documentAccountProfile.last_name]
    .filter(Boolean).join(" ");

  const companyName = companyProfile.company_name || "";

  function updateSigDate(idx, val) {
    const next = [...sigDates];
    next[idx] = val;
    setSigDates(next);
  }

  const activeBorrowers = borrowers.filter(b => b && (b.first_name || b.last_name));

  // Inline company name rendered as underlined filled text (matching PDF style)
  const CN = <span className="ba-inline-company">{companyName || "___________________________"}</span>;

  return (
    <div className="ba-doc">
      {/* Header */}
      <div className="ba-doc-header">
        {companyProfile.company_name && (
          <>
            {companyProfile.company_name}
            {companyProfile.company_state_license && `, LIC# ${companyProfile.company_state_license}`}
            {companyProfile.company_nmls_number && `, NMLS# ${companyProfile.company_nmls_number}`}
          </>
        )}
        {loName && (
          <>
            {" | Originator: "}{loName}
            {documentAccountProfile.state_real_estate_license && `, LIC# ${documentAccountProfile.state_real_estate_license}`}
            {documentAccountProfile.nmls_number && `, NMLS# ${documentAccountProfile.nmls_number}`}
          </>
        )}
      </div>

      <div className="ba-doc-title">Borrowers' Certification and Authorization</div>

      {/* CERTIFICATION */}
      <div className="ba-subsection-heading">CERTIFICATION</div>

      <p className="ba-legal-text">The Undersigned certify the following:</p>

      <ol className="ba-numbered-list">
        <li>
          I/We have applied for a mortgage loan through {CN}. In applying for the loan, I/We completed a loan
          application containing various information on the purpose of the loan, the amount and source of the down
          payment, employment and income information, and the assets and liabilities. I/We certify that all of the
          information is true and complete. I/We made no misrepresentations in the loan application or other
          documents, nor did I/We omit any pertinent information.
        </li>
        <li>
          I/We understand and agree that {CN} reserves the right to change the mortgage loan review processes to a
          full documentation program. This may include verifying the information provided on the application with
          the employer and/or the financial institution.
        </li>
        <li>
          I/We fully understand that it is a Federal crime punishable by fine or imprisonment, or both, to
          knowingly make any false statements when applying for this mortgage, as applicable under the provisions
          of Title 18, United States Code, Section 1014.
        </li>
      </ol>

      {/* AUTHORIZATION */}
      <div className="ba-subsection-heading">AUTHORIZATION TO RELEASE INFORMATION</div>

      <p className="ba-legal-text">To Whom It May Concern:</p>

      <ol className="ba-numbered-list">
        <li>
          I/We have applied for a mortgage loan through {CN}. As part of the application process, {CN} and the
          mortgage guaranty insurer (if any), may verify information contained in my/our loan application and in
          other documents required in connection with the loan, either before the loan is closed or as part of its
          quality control program.
        </li>
        <li>
          I/We authorize you to provide to {CN} and to any investor to whom {CN} may sell my mortgage, any and
          all information and documentation that they request. Such information includes, but is not limited to,
          employment history and income; bank, money market and similar account balances; credit history; and
          copies of income tax returns.
        </li>
        <li>
          {CN} or any investor that purchases the mortgage may address this authorization to any party named in
          the loan application.
        </li>
        <li>
          A copy of this authorization may be accepted as an original.
        </li>
      </ol>

      {/* Signature Lines — always 4 rows (Borrower + up to 3 Co-Borrowers) */}
      <div className="ba-sig-block">
        {[0, 1, 2, 3].map(i => {
          const b = borrowers[i] || {};
          const label = i === 0 ? "Borrower" : `Co-Borrower ${i}`;
          const name = [b.first_name, b.middle_name, b.last_name].filter(Boolean).join(" ");
          return (
            <div className="ba-sig-row" key={i}>
              <div className="ba-sig-left">
                <div className="ba-sig-name-line">{name}</div>
                <div className="ba-sig-label">{label}</div>
              </div>
              <div className="ba-sig-right">
                <input
                  className="ba-sig-date-input"
                  type="text"
                  placeholder="MM/DD/YYYY"
                  value={sigDates[i]}
                  onChange={e => updateSigDate(i, e.target.value)}
                />
                <div className="ba-sig-label">Date (MM/DD/YYYY)</div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Footer */}
      <div className="ba-form-footer">LANIS Form - (07/01/2026)</div>
    </div>
  );
}
